import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Input,
} from '@angular/core';
import { LoadingTemplateComponent } from '@freelancer/ui/loading-template';
import { AvatarSize } from '@freelancer/ui/user-avatar/user-avatar.types';

@Component({
  standalone: true,
  imports: [LoadingTemplateComponent],
  selector: 'fl-loading-avatar',
  template: ` <fl-loading-template /> `,
  styleUrls: ['./loading-avatar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoadingAvatarComponent {
  @HostBinding('attr.data-size')
  @Input()
  size: AvatarSize = AvatarSize.MID;

  @HostBinding('attr.data-size-tablet')
  @Input()
  sizeTablet?: AvatarSize;

  @HostBinding('attr.data-size-desktop')
  @Input()
  sizeDesktop?: AvatarSize;
}
